import { render } from "./ManualEntriesView.vue?vue&type=template&id=1bb36c8a&ts=true"
import script from "./ManualEntriesView.vue?vue&type=script&lang=ts"
export * from "./ManualEntriesView.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__